module.exports = __webpack_public_path__ + "img/icono_informacion.5dfcf337.jpg";